import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import Layout from "../../../components/dashboard/Layout";
import AddChapter from "../../../containers/admin/chapters/models/add-chapter";
import SearchBar from "../../../containers/admin/chapters/searchbar";
import ChaptersTable from "../../../containers/admin/chapters/table";
import AddQuestionsWallet from "../../../containers/admin/questions-wallet/models/add-questions-wallet";

import { getAllChaptersRequest } from "../../../modules/admin-modules/chapters/Actions";
import { getAllAdminSectionsRequest } from "../../../modules/admin-modules/sections/Actions";
import { useSuperAdminSubjectFilter } from "../../../helpers/useSuperAdminSubjectFilter";

const Chapters = ({
  activeFilter = 1,
  title = "الفصول",
  addButtonLabel = "إضافة فصل",
  countLabel = "عدد الفصول",
  nameColumnHeader = " الفصل",
  isQuestionsWallet = false,
}) => {
  const dispatch = useDispatch();
  const [isAdd, setAdd] = useState(false);
  const [selectedData, setSelectedData] = useState({});
  const {
    isSuperAdmin,
    selectedSubjectId,
    setSelectedSubjectId,
    subjectQuery,
    canFetch,
  } = useSuperAdminSubjectFilter();

  useEffect(() => {
    dispatch(getAllAdminSectionsRequest());
  }, [dispatch]);

  useEffect(() => {
    if (!canFetch) return;
    dispatch(getAllChaptersRequest({ active: activeFilter, ...subjectQuery }));
  }, [canFetch, activeFilter, selectedSubjectId, dispatch]);

  return (
    <Layout>
      <SearchBar
        setAdd={setAdd}
        setSelectedData={setSelectedData}
        title={title}
        activeFilter={activeFilter}
        addButtonLabel={addButtonLabel}
        countLabel={countLabel}
        isSuperAdmin={isSuperAdmin}
        selectedSubjectId={selectedSubjectId}
        setSelectedSubjectId={setSelectedSubjectId}
      />
      <ChaptersTable
        setAdd={setAdd}
        setSelectedData={setSelectedData}
        activeFilter={activeFilter}
        nameColumnHeader={nameColumnHeader}
        hideList={isSuperAdmin && !selectedSubjectId}
      />
      {isQuestionsWallet ? (
        <AddQuestionsWallet
          isAdd={isAdd}
          data={selectedData}
          setSelectedData={setSelectedData}
          active={activeFilter}
        />
      ) : (
        <AddChapter
          isAdd={isAdd}
          data={selectedData}
          setSelectedData={setSelectedData}
          active={activeFilter}
        />
      )}
    </Layout>
  );
};

export default Chapters;
